import React from "react";
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Chip,
  Card,
  CardContent,
} from "@mui/material";

const Dashboard = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Dashboard
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Account Status
              </Typography>
              <Box sx={{ mb: 2 }}>
                <Chip
                  label="Premium"
                  color="primary"
                  sx={{ mr: 1 }}
                />
                <Typography variant="body2" color="text.secondary">
                  Battles Remaining: Unlimited
                </Typography>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={8}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Battle Statistics
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Card>
                    <CardContent>
                      <Typography color="text.secondary" gutterBottom>
                        Total Battles
                      </Typography>
                      <Typography variant="h4">45</Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={4}>
                  <Card>
                    <CardContent>
                      <Typography color="text.secondary" gutterBottom>
                        Characters Used
                      </Typography>
                      <Typography variant="h4">128</Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={4}>
                  <Card>
                    <CardContent>
                      <Typography color="text.secondary" gutterBottom>
                        Battle Types
                      </Typography>
                      <Typography variant="h4">3</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Recent Battles
              </Typography>
              <List>
                {[1, 2, 3, 4, 5].map((battle) => (
                  <ListItem
                    key={battle}
                    divider
                    secondaryAction={
                      <Chip
                        label="Completed"
                        size="small"
                        color="success"
                      />
                    }
                  >
                    <ListItemText
                      primary={`Epic Battle #${battle}`}
                      secondary={`Created on ${new Date().toLocaleDateString()}`}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Dashboard;
